module.exports = "#srchBtn {\n  width: 40.9%;\n  margin-left: 0.5%;\n  border-radius: 5px;\n  float: left !important; }\n\n#dnldBtn {\n  background-color: #1bbc9c !important;\n  width: 100%;\n  margin-left: 1%;\n  border: none;\n  border-radius: 3px !important; }\n\n#dtBtn {\n  width: 100%;\n  height: 36px; }\n\n#ward {\n  font-size: 14px;\n  width: 100%;\n  height: 36px; }\n\n#zone {\n  font-size: 14px;\n  width: 100%;\n  height: 36px; }\n\n.mydrp {\n  width: 100% !important; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/reports/kccReport/kcc-dashboard.component.scss
// module id = ./src/app/reports/kccReport/kcc-dashboard.component.scss
// module chunks = main